module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-hello.05ea08a3.png";